import { Modal, Form, Button } from 'antd';
import { useStoreActions, useStoreState } from '../../store';
import { createUseStyles } from 'react-jss';
import type { PackagingSetV2 } from '../../store/services/PartnerService/types';
import { PackagingSetForm } from './PackagingSetForm';
import type { PartnerPackagingV2, PartnerPackagingV2Set } from '@shipium-corp/shipium-ts-types';

const useStyles = createUseStyles({
  modal: {},
  formContainer: {
    margin: '30px 15px 30px 15px',
  },
  avatar: {
    marginLeft: '40%',
    background: '#000',
  },
});

export const PACKAGING_SET_MODAL_KEY = 'packagingSetModalV2';
export const PackagingSetModal = () => {
  const open = useStoreState((state) => state.navigation.modals[PACKAGING_SET_MODAL_KEY]?.open);
  const activePartnerPackagingSet = useStoreState((state) => state.navigation.modals[PACKAGING_SET_MODAL_KEY]?.params);
  const closeModal = useStoreActions((actions) => actions.navigation.toggleModal);
  const createPartnerPackagingSet = useStoreActions((action) => action.packagingV2.createPackagingSet);
  const addPackagingToSet = useStoreActions((action) => action.packagingV2.addPackagingToSet);
  const partnerPackaging = useStoreState((state) => state.packagingV2.partnerPackagingV2);

  const classes = useStyles();
  const [form] = Form.useForm();

  const handleCancelClick = () => {
    form.resetFields();
    closeModal({ key: PACKAGING_SET_MODAL_KEY, open: false, params: undefined });
  };

  const handleSubmit = (event: any) => {
    form.validateFields().then(async () => {
      const values = form.getFieldsValue();
      const packagingSet: PackagingSetV2 = {
        name: values.name,
        description: values.description,
        partnerProvidedId: values.partnerProvidedId,
        active: true,
        archived: false,
      };
      if (!activePartnerPackagingSet) {
        const newPackagingSet = await createPartnerPackagingSet(packagingSet);
        for (const pckg of values.packagingIds) {
          if (newPackagingSet instanceof Error) break;
          else await addPackagingToSet({ packagingSetId: newPackagingSet.packagingSetId, packagingId: pckg });
        }
      }
      form.resetFields();
      closeModal({ key: PACKAGING_SET_MODAL_KEY, open: false, params: undefined });
    });
  };

  const footer = [
    <Button key={'cancel'} onClick={handleCancelClick}>
      Cancel
    </Button>,
    <Button key={'submit'} type="primary" onClick={handleSubmit}>
      Submit
    </Button>,
  ];

  return (
    <Modal
      title={'Create Packaging Set'}
      className={classes.modal}
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancelClick}
      footer={footer}
    >
      <PackagingSetForm
        form={form}
        activePartnerPackagingSet={activePartnerPackagingSet as PartnerPackagingV2Set}
        partnerPackaging={(partnerPackaging as PartnerPackagingV2[]) || []}
      />
    </Modal>
  );
};
